import { Directive, ElementRef, Host, HostListener, Input, Optional, Renderer2 } from '@angular/core';
import { NgControl, NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';

@Directive({
    selector: '[appIsInvalid]'
})
export class IsInvalidDirective {
    get submitted(): boolean|undefined {
        return this._submitted;
    }

    @Input()
    set submitted(value: boolean|undefined) {
        //use double ! to prevent value from being undefined
        this._submitted = !!value;
        this.updateShowValid();
    }

    @Input()
    isInvalidClass = 'is-invalid';

    private _submitted?: boolean = undefined;

    _isInvalid: boolean;
    _isInfocus: boolean;

    @Input('appIsInvalid')
    set isInvalid(invalid: boolean) {
        this._isInvalid = invalid;
        this.updateShowValid();
    }

    @Input('inFocus')
    set isInFocus(inFoucs: boolean) {
        this._isInfocus = inFoucs;
    }

    get isInvalid() {
        return this._isInvalid;
    }

    get isInFocus() {
        return this._isInfocus;
    }

    constructor(private renderer: Renderer2,
                private elementRef: ElementRef,
                @Host() @Optional() private form?: NgForm,
                @Host() @Optional() private control?: NgControl
    ) {
        if (this.form) {
            this.form.ngSubmit.pipe(take(1)).subscribe(value => {
                this.updateShowValid();
            });
        }
    }

    @HostListener('blur')
    updateShowValid() {
        if (this._isInvalid && this.showInvalid()) {
            this.addInvalidClass();
        } else {
            this.removeInvalidClass();
        }
    }

    showInvalid() {
        if (!this.form && !this.control && this._submitted === undefined) return true;
        return (this.form && this.form.submitted) || (this.control && this.control.touched) || (this._submitted !== undefined && this._submitted);
    }

    addInvalidClass() {
        this.renderer.addClass(this.elementRef.nativeElement, this.isInvalidClass);
    }

    removeInvalidClass() {
        this.renderer.removeClass(this.elementRef.nativeElement, this.isInvalidClass);
    }
    
    get controlName() {
        return this.control.name;
    }
}
